import React from 'react'
import ProgressBar from 'react-bootstrap/ProgressBar';
import QuestionBody from '../../../components/question-components/QuestionBody';
import "../../../styles/pages-styles/main-dashboard-pages-styles/question-pages-styles/QuestionBank.css"
import { useNavigate } from 'react-router-dom';

const Questionbank = () => {
  const navigate = useNavigate();

  return (
    <div className="QuestionBank-container">
      <div className="question-bank-header">
        <div>
          <h1>Question Bank</h1>
          <p>Welcome to the main question bank. </p>
          
        </div>
        <div className="question-bank-buttons">
          <button className="question-bank-button1">251 questions found</button>
          <button  
              className="question-bank-button2" 
              onClick={() => {
                navigate("/starter-question")
              }}
          >
            Start with the questions {'>'}
          </button>
        </div>
      </div>

      <div>
        <QuestionBody />
      </div>
    </div>
  );
}


export default Questionbank

